//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

function sum(x, y) {
  return x + y;
}

function square(x) {
  return x * x;
}
export default {
  name: "SlideVerify",
  props: {
    // block length
    l: {
      type: Number,
      default: 42
    },
    // block radius
    r: {
      type: Number,
      default: 10
    },
    // canvas width
    w: {
      type: Number,
      default: document.documentElement.clientWidth - 40
    },
    // canvas height
    h: {
      type: Number,
      default: (document.documentElement.clientWidth - 40) * 300 / 480
    },
    block_x: {
      type: Number,
      default: 155
    },
    block_y: {
      type: Number,
      default: 20
    },
    sliderText: {
      type: String,
      default: "Slide filled right"
    },
    imgurl: {
      type: String,
      default: ""
    },
    miniimgurl: {
      type: String,
      default: ""
    }
  },

  data() {
    return {
      containerActive: false, // container active class
      containerSuccess: false, // container success class
      containerFail: false, // container fail class
      canvasCtx: null,
      blockCtx: null,
      block: null,
      canvasStr: null,
      //block_x: undefined, // container random position
      // block_y: undefined,
      L: this.l + this.r * 2 + 3, // block real lenght
      img: undefined,
      originX: undefined,
      originY: undefined,
      isMouseDown: false,
      trail: [],
      widthlable: "",
      sliderLeft: 0, // block right offset
      sliderMaskWidth: 0, // mask width
      dialogVisible: false,
      infoText: '验证成功',
      fail: false,
      showInfo: false
    };
  },
  mounted() {
    //随机生成数this.block_x =
    this.init();
  },
  methods: {
    init() {
      this.initDom();
      this.bindEvents();
      this.widthlable = "width:" + this.w + "px;";
    },
    initDom() {
      this.block = this.$refs.block;
      this.canvasStr = this.$refs.canvas;

      this.canvasCtx = this.canvasStr.getContext("2d");
      this.blockCtx = this.block.getContext("2d");
      this.initImg()
    },
    initImg(h) {
      var that = this;
      const img = document.createElement("img");
      img.onload = onload;
      img.onerror = () => {
        img.src = that.imgurl;
      };
      img.src = that.imgurl;
      img.onload = function () {
        that.canvasCtx.drawImage(img, 0, 0, that.w, that.h);
      };

      this.img = img;
      const img1 = document.createElement("img");
      var blockCtx = that.blockCtx;
      var block_y = h || that.block_y;
      //重载后赋值
      block_y = localStorage.getItem("resetBlock_y")
      img1.onerror = () => {
        img1.src = that.miniimgurl;
      };
      img1.src = that.miniimgurl;
      //img1.style.border="1px solid #ccc"
      img1.onload = function () {
        blockCtx.drawImage(img1, 0, block_y, 55 * that.w / 480, 45 * that.h / 300);
        console.log(block_y, "newcapblock_yblock_yblock_yblock_yblock_yblock_yblock_yblock_yblock_yblock_yblock_yblock_y")
      };
      // console.log(img, img1, that.imgurl, that.miniimgurl)
    },
    refresh() {
      this.$emit("refresh");
    },
    sliderDown(event) {
      this.originX = event.clientX;
      this.originY = event.clientY;
      this.isMouseDown = true;
    },
    touchStartEvent(e) {
      this.originX = e.changedTouches[0].pageX;
      this.originY = e.changedTouches[0].pageY;
      this.isMouseDown = true;
    },
    bindEvents() {
      document.addEventListener("mousemove", e => {
        if (!this.isMouseDown) return false;
        const moveX = e.clientX - this.originX;
        const moveY = e.clientY - this.originY;
        if (moveX < 0 || moveX + 38 >= this.w) return false;
        this.sliderLeft = moveX + "px";
        let blockLeft = ((this.w - 40 - 20) / (this.w - 60)) * moveX;
        this.block.style.left = blockLeft + "px";
        this.containerActive = true; // add active
        this.sliderMaskWidth = moveX + "px";
        this.trail.push(moveY);
      });
      document.addEventListener("mouseup", e => {
        if (!this.isMouseDown) return false;
        this.isMouseDown = false;
        if (e.clientX === this.originX) return false;
        this.containerActive = false; // remove active
        this.verify();
      });
    },
    touchMoveEvent(e) {
      if (!this.isMouseDown) return false;
      const moveX = e.changedTouches[0].pageX - this.originX;
      const moveY = e.changedTouches[0].pageY - this.originY;
      if (moveX < 0 || moveX + 38 >= this.w) return false;
      this.sliderLeft = moveX + "px";
      let blockLeft = ((this.w - 40 - 20) / (this.w - 60)) * moveX;
      this.block.style.left = blockLeft + "px";
      this.containerActive = true;
      this.sliderMaskWidth = moveX + "px";
      this.trail.push(moveY);
    },
    touchEndEvent(e) {
      if (!this.isMouseDown) return false;
      this.isMouseDown = false;
      if (e.changedTouches[0].pageX === this.originX) return false;
      this.containerActive = false;
      this.verify();
    },
    verify() {
      const arr = this.trail; // drag y move distance
      const average = arr.reduce(sum) / arr.length; // average
      const deviations = arr.map(x => x - average); // deviation array
      const stddev = Math.sqrt(deviations.map(square).reduce(sum) / arr.length); // standard deviation
      const left = parseInt(this.block.style.left);
      this.$emit("success", left);
    },
    reset(h) {
      this.containerActive = false;
      this.containerSuccess = false;
      this.containerFail = false;
      this.sliderLeft = 0;
      this.block.style.left = 0;
      this.sliderMaskWidth = 0;
      this.canvasCtx.clearRect(0, 0, this.w, this.h);
      this.blockCtx.clearRect(0, 0, this.w, this.h);
      this.initImg(h);
    },
    handleFail() {
      this.fail = true
      // this.showInfo = true
      // this.infoText = '验证失败,请重试'
      this.containerFail = true
      // console.log(6666)
      // setTimeout(() => {
      //   this.block.style.left = 0;
      //   this.sliderMaskWidth = 0;
      //   this.sliderLeft = 0;
      //   this.fail = false
      //   this.showInfo = false
      //   this.containerFail = false
      // }, 3000)
      this.block.style.left = 0;
      this.sliderMaskWidth = 0;
      this.sliderLeft = 0;
      this.fail = false
      this.showInfo = false
      this.containerFail = false
    },
    handleSuccess() {
      // console.log(777)
      // this.showInfo = true
      // this.infoText = '验证成功'
      this.containerSuccess = true
      // setTimeout(() => {
      //   this.block.style.left = 0;
      //   this.sliderMaskWidth = 0;
      //   this.sliderLeft = 0;
      //   this.fail = false
      //   this.showInfo = false
      //   this.containerSuccess = false
      // }, 1000)
      this.block.style.left = 0;
      this.sliderMaskWidth = 0;
      this.sliderLeft = 0;
      this.fail = false
      this.showInfo = false
      this.containerSuccess = false
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/Newcap.vue